module.exports = "../../static/images/course-show2.573c88.png";